import React, { useState, useEffect } from "react";
import Header from "../../layout/Header";
import Sidebar from "../../layout/Sidebar";
import { Tabs } from "antd";
import Bridge from "../../constants/Bridge";
import Strings from "../../constants/Strings";
import Button from "../../components/Button";
import New from "./tabs/New";
import InProgress from "./tabs/InProgress";
import Completed from "./tabs/Completed";
import $ from "jquery";

const List = () => {
  const [featureList, setFeatureList] = useState([]);
  const [tableLoader, setTableLoader] = useState(false);
  const [listLoaded, setListLoaded] = useState(false);

  const getAllFeatureList = () => {
    setTableLoader(true);
    const param = "?user_id=" + localStorage.getItem("consortia_user_id");
    Bridge.feature_roadmap
      .list(param)
      .then((result) => {
        if (result.status === 1) {
          const sortedData = result.data.sort(
            (a, b) => new Date(b.total_votes) - new Date(a.total_votes)
          );
          setFeatureList(sortedData);
          setTableLoader(false);
          setListLoaded(true);
        } else {
          setTableLoader(false);
          setListLoaded(true);
        }
      })
      .catch(() => {
        setTableLoader(false);
        setListLoaded(true);
      });
  };

  useEffect(() => {
    if ($(window).width() < 600) {
      $("#sidebar").removeClass("show-sidebar").addClass("hide-sidebar");
    } else {
      $("#sidebar").removeClass("hide-sidebar").addClass("show-sidebar");
    }
    getAllFeatureList();
  }, []);

  const onChange = (key) => {
    console.log(key);
  };

  const items = [
    {
      key: "1",
      label: "New",
      children: listLoaded && (
        <New list={featureList} refresh={getAllFeatureList} />
      ),
    },
    {
      key: "2",
      label: "In Progress",
      children: listLoaded && (
        <InProgress list={featureList} refresh={getAllFeatureList} />
      ),
    },
    {
      key: "3",
      label: "Completed",
      children: listLoaded && <Completed list={featureList} />,
    },
  ];

  return (
    <div className="feature-roadmap-page">
      <Header />
      <div className="row">
        <Sidebar />
        <div
          className="col-lg-10"
          style={{
            marginLeft: "auto",
            backgroundColor: "#F5F5F5",
          }}
        >
          <div
            className="wrapper clearfix records-wrapper feature-roadmap-section"
            style={{ margin: 0, boxShadow: "none" }}
          >
            <div className="multisteps-form">
              <div className="row">
                <div className="col-12 col-lg-12 m-auto ecas-table">
                  <div className="row">
                    <div className="col-lg-7 ambassador-heading-section mb-2">
                      <p
                        style={{
                          position: "relative",
                          fontSize: 32,
                          fontFamily: "Open Sans",
                          fontWeight: "bold",
                          color: "#1A4F83",
                          textAlign: "start",
                        }}
                        className="mb-4 mt-4"
                      >
                        {Strings.consortiaRequests}
                      </p>
                    </div>
                    <div className="col-lg-5 filter-element ecas-search-button">
                      <Button
                        to="/consortia-requests/add"
                        isClickable={false}
                        click={false}
                        style={{
                          marginTop: 28,
                          float: "right",
                          background: "#007dfc",
                        }}
                      >
                        <i className="fas fa-plus"></i>&nbsp; New Request
                      </Button>
                    </div>
                  </div>
                  <div className="ecas-form-list">
                    <Tabs defaultActiveKey="1" items={items} onChange={onChange} />
                  </div>
                  <br />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default List;
